import type { MenuProps } from 'antd';

export const dropDownMenu: MenuProps['items'] = [
    {
        key: 'domains',
        label: 'Домены',
    },
    {
        key: 'docs',
        label: 'Документация',
    },
    {
        type: 'divider',
    },
    {
        key: 'logout',
        label: 'Выйти',
    },
];